import { useMutation, useQuery } from "@tanstack/react-query";
import { ApiServiceErr, axiosApi } from "./apiService";

export const useGetVolumeAndCost = (ownerId: string, sourceId: string) =>
  useQuery<any, ApiServiceErr>(
    [ownerId, sourceId, "getVolumeAndCost"],
    async () => {
      const response = await axiosApi.get(`/volume-and-cost/${ownerId}/${sourceId}`);
      return response?.data;
    },
    {
      cacheTime: 0,
      enabled: !!ownerId && !!sourceId
    }
  );

export const useCreateVolumeAndCost = (opt?: any) =>
  useMutation<any, ApiServiceErr, any>(async (data: any) => {
    const response = await axiosApi.post("/volume-and-cost/create", data);
    return response.data;
  }, opt);

export const useUpdateVolumeAndCost = (opt?: any) =>
  useMutation<any, ApiServiceErr, any>(async (data: any) => {
    const volumeAndCostId = data?._id;
    const response = await axiosApi.put(`/volume-and-cost/${volumeAndCostId}`, data);
    return response.data;
  }, opt);

export const useDeleteVolumeAndCost = (opt?: any) =>
  useMutation<any, ApiServiceErr, any>(async (volumeAndCostId: string) => {
    await axiosApi.delete(`/volume-and-cost/${volumeAndCostId}`);
    return;
  }, opt);
